import { isSSR } from '@helpers/ssr';
import Cookies from 'js-cookie';
import { v4 } from 'uuid';

const ALGOLIA_COOKIE_NAME = 'AlgoliaUserToken';
const ALGOLIA_PUBLIC_USER_TOKEN = 'public';

export default function (): string {
  const userToken = getUserToken();

  return userToken;
}

function getUserToken(): string {
  if (isSSR) {
    return ALGOLIA_PUBLIC_USER_TOKEN;
  }

  let existingUserToken = Cookies.get(ALGOLIA_COOKIE_NAME);

  if (!existingUserToken || existingUserToken.length === 0) {
    // Generate new guid
    existingUserToken = v4();

    if (!existingUserToken) {
      existingUserToken = ALGOLIA_PUBLIC_USER_TOKEN;
    }

    Cookies.set(ALGOLIA_COOKIE_NAME, existingUserToken, {
      expires: 365,
    });
  }

  return existingUserToken;
}
